

export function commonPrefix(arr) {
  // Returns the longest common prefix of each string element in the array
  if (!arr || arr.length === 0) {
    return '';
  }
  const min = arr.reduce((min, c) => c < min ? c : min);
  const max = arr.reduce((max, c) => c > max ? c : max);
  for (const [i, c] of min.split('').entries()) {
    if (c !== max[i]) {
      return min.substring(0, i);
    }
  }
  return min;
}

export function points2dEqual(a, b, tolerance=0.0) {
  const dx = Math.abs(a.x - b.x);
  const dy = Math.abs(a.y - b.y);
  return (dx <= tolerance && dy <= tolerance);
}

export function arraysEqual(a, b, comparator=null, context=null) {
  // Note: a zero-length array is considered equal to a 'falsy' array
  if (a === b || (!a && !b)) {
    return true;
  }
  if ((!a && b.length === 0) || (!b && a.length === 0)) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (var i = 0; i < a.length; i++) {
    if (comparator) {
      if (!comparator(a[i], b[i], context)) {
        return false;
      }
    } else {
      if (a[i] !== b[i]) {
        return false;
      }
    }
  }
  return true;
}

export function sliceIfAvailable(array, start, end) {
  if (array.length >= end) {
    return array.slice(start, end);
  } else {
    return null;
  }
}

export function valCount(val, array) {
  // Returns the number of elements of 'array' whose value is equal to 'val'
  return array.reduce((n, x) => n + (x === val), 0);
}

export function svgPathToArray(path) {
  const pointsArray = path.split(/[,\s]+/);

  // Combine pairs of numbers together
  var pairsArray = [];
  var first = null;
  var last = { 'x': null, 'y': null };
  for (var i = 0; i < pointsArray.length; i++) {
    const s = pointsArray[i];
    if (s.length > 0 && !Number.isNaN(Number(s))) {
      if (first === null) {
        first = Number(s);
      } else {
        // Make a co-ordinate pair
        const p = { 'x': first, 'y': Number(s) };
        first = null;

        // If different to last co-ordinate pair, then add to the output list
        if (!points2dEqual(p, last)) {
          pairsArray.push(p)
          last = p
        }
      }
    }
  }

  // If we have 5 co-ordinate pairs and the final co-ords equals the first co-ords
  // (i.e. a rectangle), then drop the final co-ordinate pair to leave 4 corner points.
  if (pairsArray.length === 5) {
    if (points2dEqual(pairsArray[0], pairsArray[4])) {
      pairsArray.pop();
    }
  }

  return pairsArray;
}

export function svgPathsToArrays(svg) {
  // Given a string containing one or more SVG paths, (e.g. corners + control points for tiling),
  // produce a list of points, with consecutive duplicates dropped.
  var path_parts = svg.split(/([MLC])/);
  var parse_next = false;
  var coords = [];
  for (var i = 0; i < path_parts.length; i++) {
    if (parse_next) {
      coords = coords.concat(svgPathToArray(path_parts[i]));
    }
    parse_next = (path_parts[i] === 'L' || path_parts[i] === 'C');
  }
  return coords;
}
